import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import Card from '../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { formatRupiah } from '../../../utilities/Utils'
import { FaEdit } from 'react-icons/fa'
import ModalLhpNonLalinDetilPeriksa from '../modal/ModalLhpNonLalinDetilPeriksa'

const ExpandableComponentNonLalinLHP = ({ data, idLhpHdr }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!data) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const _resDtlPeriksa = await nonLalinService.listNonlalinDtlPeriksaAll(data.trNonlalinDtlPK.nomorAju, data.trNonlalinDtlPK.seri)
                // console.log(_resDtlPeriksa)
                setListData(_resDtlPeriksa.data.data)
            } catch (error) {
                setListData([])
            }
            setLoading(false)
        }
        fetchAllData()
    }, [nonLalinService, data])

    const columns = [
        {
            name: 'Seri Tarif',
            cell: row => row['trNonlalinDtlPeriksaPK'].seriTarif,
            grow: 0.1
        },
        {
            name: 'Jenis Pengujian',
            cell: row => row['nmTarif']
        },
        {
            name: 'Tarif',
            cell: row => formatRupiah(row['tarif'])
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Volume',
            cell: row => row['volume'],
            grow: 0.2
        },
        {
            name: 'Total Tarif',
            cell: row => formatRupiah(row['totalTarif'])
        },
        {
            name: 'Kesiapan Cek UPT',
            cell: row => row['isUptCanCheck'] === 'Y' ? <><span className='text-success'>Diperiksa</span></> : <><span className='text-danger'>Tidak Diperiksa</span></>
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        {
                            localStorage.getItem('role') !== '4' && localStorage.getItem('role') !== '5' && row['isUptCanCheck'] === 'Y' &&
                            <div className='col-12 mb-1'>
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Proses Hasil Uji</Tooltip>}>
                                    <Button size='sm' variant='warning' onClick={() => ProsesHasilUji(row)}>
                                        <FaEdit /> Proses Hasil Uji
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        }
                    </div>
                </>
            )
        }
    ]

    const [dataDtlPeriksa, setDataDtlPeriksa] = useState(null)
    const [showLhpDetil, setShowLhpDetil] = useState(false)
    const handleCloseShowLhpDetil = () => setShowLhpDetil(false)

    const ProsesHasilUji = (data) => {
        setDataDtlPeriksa(data)
        setShowLhpDetil(true)
    }
    
    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <DataTable
                        customStyles={{ headCells: { style: { 'background-color': '#717475', 'color': 'white' } } }}
                        columns={columns}
                        data={listData}
                        persistTableHead={true}
                        highlightOnHover
                    />
                </Card.Body>
            </Card>
            <ModalLhpNonLalinDetilPeriksa showLhpDetil={showLhpDetil} handleCLoseModalLhpDetil={handleCloseShowLhpDetil} dataLhpPeriksa={dataDtlPeriksa} idLhpHdr={idLhpHdr}/>
        </>
    )
}

export default ExpandableComponentNonLalinLHP